export default __webpack_public_path__ + "static/media/arrow.78d13163.svg";